// First Created - 20 Aug 2026
// Author - Atul Pandey
// Purpose - API slice for User Challenge Team Evals

import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '@/app/api/apiSlice'


const userChallengeTeamEvalsAdapter = createEntityAdapter({})


const initialState =
    userChallengeTeamEvalsAdapter.getInitialState()


export const userChallengeTeamEvalsApiSlice =
    apiSlice.injectEndpoints({
        endpoints: builder => ({

            getUserChallengeTeamEvals:
                builder.query({
                    query: () => ({
                        url:
                            '/userChallengeTeamEvals/getUserChallengeTeamEvals',

                        validateStatus:
                            (response, result) => {
                                return (
                                    response.status === 200 &&
                                    !result.isError
                                )
                            },
                    }),

                    transformResponse:
                        responseData => {
                            const loadedUserChallengeTeamEvals =
                                responseData.map(
                                    userChallengeTeamEval => {
                                        userChallengeTeamEval.id =
                                            userChallengeTeamEval._id

                                        return userChallengeTeamEval
                                    }
                                )

                            return userChallengeTeamEvalsAdapter.setAll(
                                initialState,
                                loadedUserChallengeTeamEvals
                            )
                        },

                    providesTags:
                        (result, error, arg) => {
                            if (result?.ids) {
                                return [
                                    {
                                        type:
                                            'UserChallengeTeamEval',
                                        id: 'LIST',
                                    },

                                    ...result.ids.map(
                                        id => ({
                                            type:
                                                'UserChallengeTeamEval',
                                            id,
                                        })
                                    ),
                                ]
                            } else {
                                return [
                                    {
                                        type:
                                            'UserChallengeTeamEval',
                                        id: 'LIST',
                                    },
                                ]
                            }
                        },
                }),


            getUserChallengeTeamEvalsByContext:
                builder.query({
                    query: ({
                        teamEvaluatorId,
                        userId,
                        userOrgId,
                        trailId,
                        sessionId,
                        cohortId,
                        challengeId,
                        evaluationNumber,
                    }) => {

                        const params = {
                            userId,
                            userOrgId,
                            trailId,
                            sessionId,
                            cohortId,
                            challengeId,
                        }

                        if (teamEvaluatorId) {
                            params.teamEvaluatorId =
                                teamEvaluatorId
                        }

                        if (
                            evaluationNumber !== undefined &&
                            evaluationNumber !== null &&
                            evaluationNumber !== ''
                        ) {
                            params.evaluationNumber =
                                evaluationNumber
                        }

                        return {
                            url:
                                '/userChallengeTeamEvals/getUserChallengeTeamEvals/context',

                            params,

                            validateStatus:
                                (response, result) => {
                                    return (
                                        response.status === 200 &&
                                        !result.isError
                                    )
                                },
                        }
                    },

                    transformResponse:
                        responseData => {
                            const loadedUserChallengeTeamEvals =
                                responseData.map(
                                    userChallengeTeamEval => {
                                        userChallengeTeamEval.id =
                                            userChallengeTeamEval._id

                                        return userChallengeTeamEval
                                    }
                                )

                            return userChallengeTeamEvalsAdapter.setAll(
                                initialState,
                                loadedUserChallengeTeamEvals
                            )
                        },

                    providesTags:
                        (result, error, arg) => {
                            if (result?.ids) {
                                return [
                                    {
                                        type:
                                            'UserChallengeTeamEval',
                                        id: 'LIST',
                                    },

                                    ...result.ids.map(
                                        id => ({
                                            type:
                                                'UserChallengeTeamEval',
                                            id,
                                        })
                                    ),
                                ]
                            } else {
                                return [
                                    {
                                        type:
                                            'UserChallengeTeamEval',
                                        id: 'LIST',
                                    },
                                ]
                            }
                        },
                }),


            createNewUserChallengeTeamEval:
                builder.mutation({
                    query:
                        initialUserChallengeTeamEval => ({
                            url:
                                '/userChallengeTeamEvals/createNewUserChallengeTeamEval',

                            method: 'POST',

                            body: {
                                ...initialUserChallengeTeamEval,
                            },
                        }),

                    invalidatesTags: [
                        {
                            type:
                                'UserChallengeTeamEval',
                            id: 'LIST',
                        },
                    ],
                }),

        }),
    })


export const {
    useGetUserChallengeTeamEvalsQuery,
    useLazyGetUserChallengeTeamEvalsQuery,

    useGetUserChallengeTeamEvalsByContextQuery,
    useLazyGetUserChallengeTeamEvalsByContextQuery,

    useCreateNewUserChallengeTeamEvalMutation,
} = userChallengeTeamEvalsApiSlice


// returns the query result object
export const selectUserChallengeTeamEvalResult =
    userChallengeTeamEvalsApiSlice
        .endpoints
        .getUserChallengeTeamEvals
        .select()


// create memoized selector
const selectUserChallengeTeamEvalsData =
    createSelector(
        selectUserChallengeTeamEvalResult,

        userChallengeTeamEvalResult =>
            userChallengeTeamEvalResult.data
    )


// getSelectors creates these selectors and we rename them
// with aliases using destructuring
export const {
    selectAll: selectAllUserChallengeTeamEvals,
    selectById: selectUserChallengeTeamEvalById,
    selectIds: selectUserChallengeTeamEvalIds,
} =
    userChallengeTeamEvalsAdapter.getSelectors(
        state =>
            selectUserChallengeTeamEvalsData(state) ??
            initialState
    )